import { render, staticRenderFns } from "./SchemaSearchJumpConfig.vue?vue&type=template&id=355c7ae1"
import script from "./SchemaSearchJumpConfig.vue?vue&type=script&lang=js"
export * from "./SchemaSearchJumpConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports